import FormProviderControl from './FormProviderControl';

export default FormProviderControl;
export type { IFormProviderControlProps } from './FormProviderControl';
